import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { SecondaryButton, TransparentBgButton } from 'components/Shared/Button'
import PortalModal from 'components/Shared/PortalModal'

export function Prompt({
  isOpen,
  forUnmatched,
  forUnmatchedWithNoExistingCustomerIds,
  forDeleted,
  forClearing,
  onYes,
  onNo,
}) {
  const { t } = useTranslation()

  const title = useMemo(() => {
    if (forUnmatched) {
      return t('PackageBuilder.customerSegmentation.customerMatching.unsavedChangesPrompt.unmatchedTitle')
    }

    if (forDeleted) {
      return t('PackageBuilder.customerSegmentation.customerMatching.unsavedChangesPrompt.deletedTitle')
    }

    if (forClearing) {
      return t('PackageBuilder.customerSegmentation.customerMatching.unsavedChangesPrompt.clearedTitle')
    }

    return ''
  }, [forUnmatched, forDeleted, forClearing, t])

  const description = useMemo(() => {
    if (forUnmatchedWithNoExistingCustomerIds) {
      return t(
        'PackageBuilder.customerSegmentation.customerMatching.unsavedChangesPrompt.unmatchedDescriptionWithNoExistingCustomerIds',
      )
    } else if (forUnmatched) {
      return t('PackageBuilder.customerSegmentation.customerMatching.unsavedChangesPrompt.unmatchedDescription')
    }

    if (forDeleted) {
      return t('PackageBuilder.customerSegmentation.customerMatching.unsavedChangesPrompt.deletedDescription')
    }

    if (forClearing) {
      return t('PackageBuilder.customerSegmentation.customerMatching.unsavedChangesPrompt.clearedDescription')
    }
  }, [forUnmatched, forDeleted, forClearing, t, forUnmatchedWithNoExistingCustomerIds])

  const cancel = useMemo(() => {
    if (forUnmatchedWithNoExistingCustomerIds) {
      return t('PackageBuilder.customerSegmentation.customerMatching.unsavedChangesPrompt.cancelRemove')
    } else if (forUnmatched) {
      return t('common.cancel')
    }

    if (forDeleted || forClearing) {
      return t('PackageBuilder.customerSegmentation.customerMatching.unsavedChangesPrompt.cancelDelete')
    }
  }, [t, forUnmatched, forUnmatchedWithNoExistingCustomerIds, forDeleted, forClearing])

  const proceed = useMemo(() => {
    if (forUnmatchedWithNoExistingCustomerIds) {
      return t('PackageBuilder.customerSegmentation.customerMatching.unsavedChangesPrompt.proceedRemove')
    } else if (forUnmatched) {
      return t('common.yesProceed')
    }

    if (forDeleted || forClearing) {
      return t('PackageBuilder.customerSegmentation.customerMatching.unsavedChangesPrompt.proceedDelete')
    }
  }, [t, forUnmatched, forUnmatchedWithNoExistingCustomerIds, forDeleted, forClearing])

  return (
    <PortalModal isOpen={isOpen} onClickOutside={onNo}>
      <div className="content compact text-center" style={{ maxWidth: '420px' }}>
        <h1 className="autofill_warning-header">{title}</h1>
        <p className="autofill_warning-msg">{description}</p>
        <div className="footer">
          <TransparentBgButton text={cancel} onClick={onNo} color="navy" />
          <SecondaryButton color="orange" text={proceed} onClick={onYes} type="button" disabledTitle="" />
        </div>
      </div>
    </PortalModal>
  )
}
Prompt.propTypes = {
  isOpen: PropTypes.bool,
  forUnmatched: PropTypes.bool,
  forUnmatchedWithNoExistingCustomerIds: PropTypes.bool,
  forDeleted: PropTypes.bool,
  forClearing: PropTypes.bool,
  onYes: PropTypes.func.isRequired,
  onNo: PropTypes.func.isRequired,
}
